// extracted by mini-css-extract-plugin
export default {"canvasRoot":"VNZd19goAQrRK3AWc3Eg"};